import HandleCloseAlert from '../functions/close-alert';
import { clearWishlist, getWishlist } from '../functions/wishlist';
export default function RequestOfferWishlist() {
    const requestOfferBtn = document.getElementById('requestOfferBtn');
    const wishlistProducts = document.querySelector('#wishlistProducts');

    if (requestOfferBtn) {
        requestOfferBtn.addEventListener('click', () => {
            requestOfferWishlist();
        });
    }

    const requestOfferWishlist = async () => {
        const wishlist = getWishlist();
        if (document.querySelector('.form-alert')) {
            document.querySelectorAll('.form-alert-close').forEach(() => {
                document.querySelector('.form-alert').remove();
            });
        }
        if (wishlist.length === 0) return;
        requestOfferBtn.classList.add('--loading');
        try {
            const { url } = ajax;
            const formData = new FormData();
            const summaryTerms = document.querySelectorAll(
                '.wishlist input[id^="summary_term_"]'
            );
            const newsletterTerm = document.getElementById('userNewsletter');

            formData.append('action', 'request_offer_wishlist');
            formData.append('product_ids', JSON.stringify(wishlist));
            summaryTerms.forEach((term, index) => {
                formData.append(`summary_term_${index}`, term.checked);
            });

            if (newsletterTerm) {
                formData.append('user_newsletter', newsletterTerm.checked);
            }

            const req = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            if (!req.ok) throw new Error('Błąd');

            const response = await req.json();

            if (response.data.html) {
                requestOfferBtn.classList.remove('--loading');
                const responseAlert = response.data.html;
                document
                    .querySelector('.wishlist__card__summary')
                    .insertAdjacentHTML('beforeend', `${responseAlert}`);

                if (response.success) {
                    wishlistProducts.innerHTML = '';
                    clearWishlist('wishlist');
                    requestOfferBtn.classList.add('--disabled');
                    requestOfferBtn.disabled = true;
                }
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            HandleCloseAlert();
        }
    };
}
